import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from '@lifeomic/chroma-react/components/Button';
import { Menu, MenuItem } from '@lifeomic/chroma-react/components/Menu';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { useAssignableConsents } from './useAssignableConsents';

const messages = defineMessages({
  assignConsent: {
    id: 'patientViewer.subjectConsent.assignConsent',
    defaultMessage: 'Assign Consent',
  },
  assignConsentLabel: {
    id: 'patientViewer.subjectConsent.assignConsentLabel',
    defaultMessage: 'Assign {title}',
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1),
  },
}));

export const AssignableConsentMenu = ({
  patientId,
  onConsentAssigned,
}: {
  patientId: string;
  onConsentAssigned: () => void | Promise<void>;
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});
  const {
    assignableConsents,
    assignConsent,
    isLoadingAssignableConsents,
    isAssigningConsent,
  } = useAssignableConsents({ patientId, onConsentAssigned });

  if (!assignableConsents.length && !isLoadingAssignableConsents) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Menu
        aria-label={formatMessage(messages.assignConsent)}
        anchorElement={
          <Button
            disabled={isLoadingAssignableConsents || isAssigningConsent}
            variant="outlined"
          >
            {formatMessage(messages.assignConsent)}
          </Button>
        }
        items={assignableConsents.map(consent => (
          <MenuItem
            key={consent.questionnaireId}
            onClick={() => assignConsent(consent)}
            disabled={isAssigningConsent}
            aria-label={formatMessage(messages.assignConsentLabel, {
              title: consent.title,
            })}
          >
            {consent.title}
          </MenuItem>
        ))}
      />
    </div>
  );
};

export default React.memo(AssignableConsentMenu);
